export default function getTagList(text) {
  if (!text) return null;

  let array = text.match(/#\w+/g);
  let tagList = [];
  if (array) {
    const list = array.map((item) => {
      return item.substring(1);
    });
    tagList = [...new Set(list)];
  }

  return tagList;
}
